import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { ApiResult } from 'src/app/enums/core/ApiResult';
import { SnackData } from './interfaces/SnackData.interface';

@Component({
selector: 'app-snack',
  templateUrl: './snack.component.html',
  styleUrls: ['./snack.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SnackComponent {

  readonly CSS_DANGER = 'danger';
  readonly CSS_SUCCESS = 'success';
  readonly CSS_WARNING = 'warning';
  readonly CSS_INFO = 'info';

  css: string = '';

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackData) { }

  ngOnInit(): void {
    this.setCss();
  }

  setCss(): void {
    let css = '';
    switch (this.data.message) {
      case ApiResult.ERROR_CREATE_DELIVERY:
        css = this.CSS_DANGER;
        break;
      case ApiResult.ERROR_CREATE_DELIVERYSECTION:
        css = this.CSS_DANGER;
        break;
      case ApiResult.ERROR_UPDATE_DELIVERYSECTION:
        css = this.CSS_DANGER;
        break;
      case ApiResult.ERROR_EXPORT:
        css = this.CSS_DANGER;
        break;
      case ApiResult.ERROR_CREATE_DELIVERY_ALREADY_EXIST:
        css = this.CSS_DANGER;
        break;
      case ApiResult.ERROR_CREATE_DELIVERYSECTION_ALREADY_EXIST:
        css = this.CSS_DANGER;
        break;
      case ApiResult.ERROR_UPDATE_DELIVERY:
        css = this.CSS_DANGER;
        break;
      case ApiResult.ERROR_CREATE_CONTRACT:
        css = this.CSS_DANGER;
        break;
      case ApiResult.ERROR_UPDATE_CONTRACT:
        css = this.CSS_DANGER;
        break;
      default:
        css = this.CSS_INFO;
        break;
    }

    this.css = css;
  }
}
